import { connect } from "react-redux";
import PremierSubscriptionPlans from "../../components/PremierSubscriptionPlans/index.jsx";
import { fetchSubscriptionPlans } from "../../actions/SubscriptionPlans";
import { addPremierSubscription } from "../../actions/PremierProposition";
import { toggleModal } from "../../actions/Modal";

const mapStateToProps = (state) => ({
  status: state.SubscriptionPlans.status,
  plans: state.SubscriptionPlans.plans,
  selectedCountry: state.PremierSelectorOptions.selectedCountry,
  premierSubscriptionAdded: state.PremierProposition.premierSubscriptionAdded,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSubscriptionPlans: (country, currency, language) => {
    dispatch(fetchSubscriptionPlans(country, currency, language));
  },
  addPremierSubscription: (subscriptionId) =>
    dispatch(addPremierSubscription(subscriptionId)),
  openTermsAndConditions: (termsUrl) => {
    dispatch(toggleModal(true, document.activeElement, termsUrl));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremierSubscriptionPlans);
